import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/news";
import { formatViews, getCategoryByName } from "@/lib/news";

export default function NewsCard({ news }: { news: NewsItem }) {
  const cat = getCategoryByName(news.category);

  return (
    <Link
      to={`/detail/${news.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden bg-background-200">
        <img
          src={news.cover}
          alt={`${news.title} - 91爆料热点新闻配图`}
          title={`${news.title} - 91爆料`}
          className="h-44 w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-primary-600/90 px-2 py-1 text-xs font-medium text-background-50">
          {cat ? cat.name : news.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
          {news.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-500">{news.summary}</p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {news.publishDate}
          </span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(news.views)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-thumb-up-line"></i>
              {formatViews(news.likes)}
            </span>
          </span>
        </div>
      </div>
    </Link>
  );
}